function openCartDrawer() {
  document.querySelector("body").style.overflow = "hidden";
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document.querySelector("body").style.overflow = '';
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document.querySelectorAll("[data-cart-count]").forEach((el) => {
    el.textContent = count;
  });
}

function countDownTimer()
{
  // Load saved time or start from 9:00
  let [minutes, seconds] = JSON.parse(localStorage.getItem('countdown')) || [9, 0];

  // Function to update the timer
  function updateTimer() {
    if (minutes === 0 && seconds === 0) {
      minutes = 9;
      seconds = 0;
    } else if (seconds === 0) {
      minutes--;
      seconds = 59;
    } else {
      seconds--;
    }

    // Save state to localStorage
    localStorage.setItem('countdown', JSON.stringify([minutes, seconds]));
    
    // Update display
    document.getElementById('cdh-order-timer').textContent = `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
  }

  // Start the countdown 
  setInterval(updateTimer, 1000);
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
}

function addCartDrawerListeners() {
  // Update quantities
    document
    .querySelectorAll(".cart-drawer-quantity-update")
    .forEach((input) => {
      input.addEventListener("change", async () => {
        // Get line item key
        const rootItem =
          input.closest('.cart-drawer-item');
        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const newQuantity = input.value;

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });

  // remove items
  document.querySelectorAll(".cart-drawer-item-remove")
    .forEach(remove =>{
      remove.addEventListener('click', async (e)=> {
        e.preventDefault();

        const item = remove.closest(".cart-drawer-item");
        const key = item.getAttribute("data-line-item-key");

        // Ajax update
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: 0 } }),
        });

        const cart = await res.json();
        
        // count update
        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      })
    })

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        closeCartDrawer();
      });
    });
}

addCartDrawerListeners();

const items = document.querySelectorAll(".cart-drawer-item");
if(items.length > 0)
  countDownTimer();

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});
